export function replaceDomainUrl(url: string) {
  const base = window.location.hostname.split('.')[1];
  return base === 'viessmann' ? url.replace('viessmann-climatesolutions.com', 'viessmann.com') : url;
}
